import { render, staticRenderFns } from "./ChangePriorityTask.vue?vue&type=template&id=46747bbc&scoped=true"
import script from "./ChangePriorityTask.vue?vue&type=script&lang=ts"
export * from "./ChangePriorityTask.vue?vue&type=script&lang=ts"
import style0 from "./ChangePriorityTask.vue?vue&type=style&index=0&id=46747bbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46747bbc",
  null
  
)

export default component.exports